import { useEffect, useRef, useState } from "react";
import { motion, useInView, useReducedMotion, animate } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", ...props }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, margin: "-60px" }}
      transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      {eyebrow && (
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-dt-accent mb-4" data-testid="section-eyebrow">
          {eyebrow}
        </p>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-dt-text">
        {title}
      </h2>
      {sub && <p className="mt-4 text-base sm:text-lg text-dt-muted max-w-2xl leading-relaxed" style={align === "center" ? { marginLeft: "auto", marginRight: "auto" } : {}}>{sub}</p>}
    </Reveal>
  );
}

export function CountUp({ to = 0, suffix = "", prefix = "", duration = 1.6, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const reduced = useReducedMotion();
  const [val, setVal] = useState(reduced ? to : 0);

  useEffect(() => {
    if (!inView) return;
    if (reduced) { setVal(to); return; }
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, duration, reduced]);

  return (
    <span ref={ref} className={className} data-testid="countup-stat">
      {prefix}{val.toLocaleString()}{suffix}
    </span>
  );
}
